import AnalyticsService from '@root/core/src/services/analytics-service';
import LinkButton from '@root/gatsby-contentful-core/src/components/buttons/link-button';
import LinkButtonModel from '@root/gatsby-contentful-core/src/models/link-button';
import { constantize } from '@root/core/src/utils/strings';
import { isRelativeLink } from '@root/gatsby-contentful-core/src/components/smart-link/helpers';
import { useLocation } from '@reach/router';

export default class InterfaceActionsService {
  static buildCallToActionButton({
    interfaceActionsMap,
    button,
    trackClick = () => {},
  }) {
    if (!button) { return; }

    const {
      buttonText,
      buttonLink,
      buttonAction,
      buttonType,
      forwardQueryParams,
      modal,
    } = button;

    const titleSlug = AnalyticsService.normalizeForAnalyticsContext(buttonText);

    const trackCTAClick = () => {
      trackClick(`CTA_BUTTON_${titleSlug}`, {
        buttonText,
        buttonLink,
        buttonAction,
      });
    };

    if (modal) {
      const ModalButton = interfaceActionsMap.idToComponentMap['openHubspotModal'];
      return () => (
        <ModalButton
          modal={modal}
          onClick={() => trackCTAClick()}
          variant={buttonType.toLowerCase()}
        >
          {buttonText}
        </ModalButton>
      );
    }

    if (forwardQueryParams) {
      return function ForwardingCTAButton() {
        const { search } = useLocation();
        const to = appendSearchParams(buttonLink, search);
        return (
          <LinkButton
            onClick={() => trackClick(`CTA_BUTTON_${titleSlug}`, {
              buttonText,
              buttonLink: to,
              buttonAction,
            })}
            to={to}
            type={LinkButtonModel.types[constantize(buttonType)]}
          >
            {buttonText}
          </LinkButton>
        );
      };
    }

    return () => (
      <LinkButton
        onClick={() => trackCTAClick()}
        to={buttonLink}
        type={LinkButtonModel.types[constantize(buttonType)]}
      >
        {buttonText}
      </LinkButton>
    );
  }
}

function appendSearchParams(buttonLink, search) {
  if (!search || typeof search !== 'string' || isRelativeLink(buttonLink)) { return buttonLink; }
  let url;
  try {
    url = new URL(buttonLink);
  } catch {
    return buttonLink;
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') { return buttonLink; }
  new URLSearchParams(search).forEach((value, key) => {
    if (!url.searchParams.has(key)) {
      url.searchParams.set(key, value);
    }
  });
  return url.href;
}

export { appendSearchParams };
